module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": _vm.showmenu_bar,
      "index": "11"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('join.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[0]),
      expression: "imglist[0]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item",
    staticStyle: {
      "margin-bottom": "0.7rem"
    }
  }, [_c('ul', {
    staticClass: "about_list clearfix"
  }, [_c('li', {
    staticClass: "about_item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text6'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vr_cloud_box_split"
  }), _vm._v(" "), _c('div', {
    staticClass: "about_item_text",
    staticStyle: {
      "margin-bottom": "0.15rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text7'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "about_item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "about_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text10'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vr_cloud_box_split"
  }), _vm._v(" "), _c('div', {
    staticClass: "about_item_text",
    staticStyle: {
      "margin-bottom": "0.15rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text11'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "about_item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "about_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text8'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vr_cloud_box_split"
  }), _vm._v(" "), _c('div', {
    staticClass: "about_item_text",
    staticStyle: {
      "margin-bottom": "0.15rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text9'))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "background": "#f4f8fc"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text12'))
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "7.5rem",
      "height": "3.12rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    staticStyle: {
      "width": "7.5rem",
      "height": "3.12rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text14'))
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    staticStyle: {
      "width": "7.5rem",
      "height": "5.45rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[5]),
      expression: "imglist[5]"
    }],
    staticStyle: {
      "width": "7.5rem",
      "height": "5.45rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n            热招职位\n          ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[3]),
      expression: "imglist[3]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg",
    staticStyle: {
      "padding-top": "0"
    }
  }, [_vm._m(4)])]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n            Open Positions\n          ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[3]),
      expression: "imglist[3]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg",
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0.5rem"
    }
  }, [_vm._m(6)])]) : _vm._e()]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_item1"
  }, [_c('span', {
    staticClass: "about_item_icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_item2"
  }, [_c('span', {
    staticClass: "about_item_icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_item3"
  }, [_c('span', {
    staticClass: "about_item_icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "job_list"
  }, [_c('dt', {
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_vm._v("\n              视频算法工程师\n            ")]), _vm._v(" "), _c('dd', {
    staticClass: "job_text"
  }, [_vm._v("\n              25k-50k / 深圳 / 经验5-10年 / 本科及以上 / 全职\n            ")]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "button_default2",
    attrs: {
      "href": "https://www.lagou.com/jobs/3419777.html",
      "target": "_blank"
    }
  }, [_vm._v("查看职位")])]), _vm._v(" "), _c('dt', [_vm._v("\n              Android客户端开发工程师\n            ")]), _vm._v(" "), _c('dd', {
    staticClass: "job_text"
  }, [_vm._v("\n              18k-30k / 深圳 / 经验3-5年 / 本科及以上 / 全职\n            ")]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "button_default2",
    attrs: {
      "href": "https://www.lagou.com/jobs/2642148.html",
      "target": "_blank"
    }
  }, [_vm._v("查看职位")])]), _vm._v(" "), _c('dt', [_vm._v("\n              高级产品运营经理（2B方向)\n            ")]), _vm._v(" "), _c('dd', {
    staticClass: "job_text"
  }, [_vm._v("\n              18k-30k / 深圳 / 经验5-10年 / 学历不限 / 全职\n            ")]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "button_default2",
    attrs: {
      "href": "https://www.lagou.com/jobs/2949766.html",
      "target": "_blank"
    }
  }, [_vm._v("查看职位")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center",
    staticStyle: {
      "padding-top": "0.2rem"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "0.24rem",
      "color": "rgb(35,138,247)",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://www.lagou.com/gongsi/j149944.html",
      "target": "_blank"
    }
  }, [_vm._v("查看更多职位")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "job_list"
  }, [_c('dt', {
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_vm._v("\n              Sr. Software Engineer (Millbrae, CA)\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center",
    staticStyle: {
      "padding-top": "0.2rem"
    }
  }, [_c('a', {
    staticClass: "button_default2",
    attrs: {
      "href": "mailto:hr@vrviu.com",
      "target": "_blank"
    }
  }, [_vm._v("Apply Now")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b721ae9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/join.vue
// module id = 101
// module chunks = 0